<template>
    <div>
        <a-table
                :row-key="rowKey"
                :dataSource="dataSet.items"
                :pagination="false"
                size="middle"
                :scroll="{x : true, y: 0}"
                class="bg-white"
                @change="tableChange"
                :custom-row="customRow"
                :row-class-name="rowClassName">
            <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot"/>
            <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
                <slot :name="slot" v-bind="scope"/>
            </template>
        </a-table>
        <div class="flex mt-4" v-if="paginationVisible">
            <a-pagination
                    class="ml-auto"
                    ref="pagination"
                    layout="prev, pager, next"
                    :page-size="query.pageSize"
                    v-model="query.page"
                    :total="dataSet.totalItems"
                    :show-total="(total, range) => `${range[0]}-${range[1]} of ${total} items`"
                    showSizeChanger
                    :page-size-options="['10', '50', '100']"
                    @change="pageChange"
                    @showSizeChange="pageChange">
                <template slot="buildOptionText" slot-scope="props">
                    {{ $t("pagination", [props.value]) }}
                </template>
            </a-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            rowKey: {
                type: String,
                required: true
            },
            dataSet: {
                type: Object,
                default: () => {
                    return {
                        items: [],
                        totalItems: 0
                    }
                }
            },
            query: {
                type: Object,
                default: () => {
                    return {
                        ordering: [],
                        page: 1,
                        pageSize: 10,
                    }
                }
            },
            paginationVisible: {
                type: Boolean,
                default: true
            },
            actionRows: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            camelToSnake(string) {
                return string.replace(/[\w]([A-Z])/g, function (m) {
                    return m[0] + "_" + m[1];
                }).toLowerCase();
            },
            pageChange(page, pageSize) {
                this.query.page = page;
                this.query.pageSize = pageSize;
                this.$emit('change', this.query)

            },
            tableChange(pagination, filter, sorter) {
                if (sorter.order == null) {
                    this.query.ordering = [];
                } else {
                    this.query.ordering = [{
                        field: sorter.column.key,
                        asc: sorter.order === 'ascend',
                    }];
                }
                this.$emit('change', this.query)
            },
            rowClassName() {
                return this.actionRows ? 'action-row' : '';
            },
            customRow(record) {
                return {
                    on: {
                        click: () => {
                            this.$emit('row-click', record);
                        },
                    },
                };
            }
        }
    }
</script>
